
export const hasEmojiValidation = (text) => {
    const emojiRegex = /[\p{Emoji_Presentation}\uFE0F\u200D]/gu;
    return emojiRegex.test(text);
  };


export const disableItemSelection = (preferences) => {
    const columns = preferences?.columns?.filter(item => item.show === true)
    return columns?.length === 0
  }